import { createContext } from "react";
import { PageModel } from "../types/PageModel";

export const PageContext = createContext<PageModel | null>(null);
